import { createGlobalStyle } from "styled-components";
import "@fontsource/open-sans/300.css"; // light
import "@fontsource/open-sans/400.css"; // regular
import "@fontsource/open-sans/500.css"; // medium
import "@fontsource/open-sans/600.css"; // semibold
import "@fontsource/open-sans/700.css"; // bold

export const GlobalStyles = createGlobalStyle`
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    font-family: 'Open Sans', sans-serif;
  }

  html, body {
    margin: 0;
    padding: 0;
    overflow-x: hidden;
    min-height: 100vh;
  }

  body {
    line-height: 1.5;
  }

  button {
    cursor: pointer;
    border: none;
    background: none;
    font-family: inherit;
  }

  a {
    color: inherit;
    text-decoration: none;
  }
`;
